// This file is auto-generated by @hey-api/openapi-ts

import {
  createClient,
  createConfig,
  type Options,
  urlSearchParamsBodySerializer,
} from "@hey-api/client-fetch";
import type {
  GetJwksEhealthWellKnownJwksGetData,
  GetJwksEhealthWellKnownJwksGetError,
  GetJwksEhealthWellKnownJwksGetResponse,
  LoginEhealthEhealthLoginGetData,
  LoginEhealthEhealthLoginGetError,
  LoginEhealthEhealthLoginGetResponse,
  HandleEhealthCallbackEhealthCallbackGetError,
  HandleEhealthCallbackEhealthCallbackGetResponse,
  LoginEntraEntraLoginGetData,
  LoginEntraEntraLoginGetError,
  LoginEntraEntraLoginGetResponse,
  HandleEntraCallbackEntraCallbackGetError,
  HandleEntraCallbackEntraCallbackGetResponse,
  LoginEntraGoogleLoginGetData,
  LoginEntraGoogleLoginGetError,
  LoginEntraGoogleLoginGetResponse,
  HandleEntraCallbackGoogleCallbackGetError,
  HandleEntraCallbackGoogleCallbackGetResponse,
  LaunchAppFromEhrSmartLaunchGetData,
  LaunchAppFromEhrSmartLaunchGetError,
  LaunchAppFromEhrSmartLaunchGetResponse,
  HandleSofCallbackSmartCallbackGetError,
  HandleSofCallbackSmartCallbackGetResponse,
  GetSessionSessionGetError,
  GetSessionSessionGetResponse,
  CreateSessionSessionPostData,
  CreateSessionSessionPostError,
  CreateSessionSessionPostResponse,
  DeleteSessionSessionDeleteError,
  DeleteSessionSessionDeleteResponse,
  ExchangeIdentityTokenTokenPostData,
  ExchangeIdentityTokenTokenPostError,
  ExchangeIdentityTokenTokenPostResponse,
  GenerateSecretSecretGetError,
  GenerateSecretSecretGetResponse,
  LoginPageUiLoginGetData,
  LoginPageUiLoginGetError,
  LoginPageUiLoginGetResponse,
  TestPageUiTestGetData,
  TestPageUiTestGetError,
  TestPageUiTestGetResponse,
  EmailLinkPageUiEmailLinkGetData,
  EmailLinkPageUiEmailLinkGetError,
  EmailLinkPageUiEmailLinkGetResponse,
  HandleSessionPageUiHandleSessionGetData,
  HandleSessionPageUiHandleSessionGetError,
  HandleSessionPageUiHandleSessionGetResponse,
  MainGetError,
  MainGetResponse,
} from "./types.gen";

export const client = createClient(createConfig());

/**
 * Get Jwks
 */
export const getJwksEhealthWellKnownJwksGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetJwksEhealthWellKnownJwksGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetJwksEhealthWellKnownJwksGetResponse,
    GetJwksEhealthWellKnownJwksGetError,
    ThrowOnError
  >({
    ...options,
    url: "/ehealth/.well-known/jwks",
  });
};

/**
 * Login page for the given authentication provider.
 */
export const loginEhealthEhealthLoginGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<LoginEhealthEhealthLoginGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    LoginEhealthEhealthLoginGetResponse,
    LoginEhealthEhealthLoginGetError,
    ThrowOnError
  >({
    ...options,
    url: "/ehealth/login",
  });
};

/**
 * Callback after authorization request with the authorization code and state.
 */
export const handleEhealthCallbackEhealthCallbackGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    HandleEhealthCallbackEhealthCallbackGetResponse,
    HandleEhealthCallbackEhealthCallbackGetError,
    ThrowOnError
  >({
    ...options,
    url: "/ehealth/callback",
  });
};

/**
 * Login page for the given authentication provider.
 */
export const loginEntraEntraLoginGet = <ThrowOnError extends boolean = false>(
  options: Options<LoginEntraEntraLoginGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    LoginEntraEntraLoginGetResponse,
    LoginEntraEntraLoginGetError,
    ThrowOnError
  >({
    ...options,
    url: "/entra/login",
  });
};

/**
 * Callback after authorization request with the authorization code and state.
 */
export const handleEntraCallbackEntraCallbackGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    HandleEntraCallbackEntraCallbackGetResponse,
    HandleEntraCallbackEntraCallbackGetError,
    ThrowOnError
  >({
    ...options,
    url: "/entra/callback",
  });
};

/**
 * Login page for the given authentication provider.
 */
export const loginEntraGoogleLoginGet = <ThrowOnError extends boolean = false>(
  options: Options<LoginEntraGoogleLoginGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    LoginEntraGoogleLoginGetResponse,
    LoginEntraGoogleLoginGetError,
    ThrowOnError
  >({
    ...options,
    url: "/google/login",
  });
};

/**
 * Callback after authorization request with the authorization code and state.
 */
export const handleEntraCallbackGoogleCallbackGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    HandleEntraCallbackGoogleCallbackGetResponse,
    HandleEntraCallbackGoogleCallbackGetError,
    ThrowOnError
  >({
    ...options,
    url: "/google/callback",
  });
};

/**
 * When the app is launched from the EHR a GET is sent with the iss and launch code.
 */
export const launchAppFromEhrSmartLaunchGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<LaunchAppFromEhrSmartLaunchGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    LaunchAppFromEhrSmartLaunchGetResponse,
    LaunchAppFromEhrSmartLaunchGetError,
    ThrowOnError
  >({
    ...options,
    url: "/smart/launch",
  });
};

/**
 * Callback after authorization request with the authorization code and state.
 */
export const handleSofCallbackSmartCallbackGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    HandleSofCallbackSmartCallbackGetResponse,
    HandleSofCallbackSmartCallbackGetError,
    ThrowOnError
  >({
    ...options,
    url: "/smart/callback",
  });
};

/**
 * Get Session
 */
export const getSessionSessionGet = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetSessionSessionGetResponse,
    GetSessionSessionGetError,
    ThrowOnError
  >({
    ...options,
    url: "/session",
  });
};

/**
 * Create Session
 * Exchanges a firebase id token for an auth session cookie with the created auth session id.
 */
export const createSessionSessionPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateSessionSessionPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateSessionSessionPostResponse,
    CreateSessionSessionPostError,
    ThrowOnError
  >({
    ...options,
    ...urlSearchParamsBodySerializer,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      ...options?.headers,
    },
    url: "/session",
  });
};

/**
 * Delete Session
 */
export const deleteSessionSessionDelete = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteSessionSessionDeleteResponse,
    DeleteSessionSessionDeleteError,
    ThrowOnError
  >({
    ...options,
    url: "/session",
  });
};

/**
 * ID Token Exchange
 * This Token Exchange lets clients exchange their ID tokens issued by other (trusted) parties for an ID token issued by Tiro.health that accepted in all Tiro.health applications.
 *
 * There mainly two ways this API can be helpfull:
 * - exchange trusted ID tokens for Tiro.health's ID tokens
 * - impersonate an end-user given a trusted client (based on id and secret).
 *
 * The API is build along the [specifications of OAuth 2.0](https://www.rfc-editor.org/rfc/rfc8693).
 *
 * ### ⚠️ Caveat
 * - The response will have a field called `access_token` but **it will contain a token matching the `requested_token_type`** which is most often an ID token.
 */
export const exchangeIdentityTokenTokenPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ExchangeIdentityTokenTokenPostData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ExchangeIdentityTokenTokenPostResponse,
    ExchangeIdentityTokenTokenPostError,
    ThrowOnError
  >({
    ...options,
    ...urlSearchParamsBodySerializer,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      ...options?.headers,
    },
    url: "/token",
  });
};

/**
 * Provides random secure tokens with 32 hexadecimal symbols.
 */
export const generateSecretSecretGet = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GenerateSecretSecretGetResponse,
    GenerateSecretSecretGetError,
    ThrowOnError
  >({
    ...options,
    url: "/secret",
  });
};

/**
 * Login Page
 */
export const loginPageUiLoginGet = <ThrowOnError extends boolean = false>(
  options?: Options<LoginPageUiLoginGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    LoginPageUiLoginGetResponse,
    LoginPageUiLoginGetError,
    ThrowOnError
  >({
    ...options,
    url: "/ui/login",
  });
};

/**
 * Test Page
 */
export const testPageUiTestGet = <ThrowOnError extends boolean = false>(
  options: Options<TestPageUiTestGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    TestPageUiTestGetResponse,
    TestPageUiTestGetError,
    ThrowOnError
  >({
    ...options,
    url: "/ui/test",
  });
};

/**
 * Email Link Page
 */
export const emailLinkPageUiEmailLinkGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<EmailLinkPageUiEmailLinkGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    EmailLinkPageUiEmailLinkGetResponse,
    EmailLinkPageUiEmailLinkGetError,
    ThrowOnError
  >({
    ...options,
    url: "/ui/email-link",
  });
};

/**
 * Handle Session Page
 */
export const handleSessionPageUiHandleSessionGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<HandleSessionPageUiHandleSessionGetData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    HandleSessionPageUiHandleSessionGetResponse,
    HandleSessionPageUiHandleSessionGetError,
    ThrowOnError
  >({
    ...options,
    url: "/ui/handle-session",
  });
};

/**
 * Main
 */
export const mainGet = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    MainGetResponse,
    MainGetError,
    ThrowOnError
  >({
    ...options,
    url: "/",
  });
};
